import { render, staticRenderFns } from "./ShippingPackage.vue?vue&type=template&id=e236c02c&scoped=true&lang=pug&"
import script from "./ShippingPackage.vue?vue&type=script&lang=js&"
export * from "./ShippingPackage.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPackage.vue?vue&type=style&index=0&id=e236c02c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e236c02c",
  null
  
)

/* custom blocks */
import block0 from "./ShippingPackage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports